var _rect, _g, _line, _line2, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHeaderBottom(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 256,
    height: 50,
    viewBox: "0 0 256 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_945_129",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 100,
    y: 0,
    width: 50,
    height: 50
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 100,
    width: 50,
    height: 50,
    fill: "url(#pattern0)"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_945_129)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 99,
    y: -16,
    width: 126,
    height: 144,
    fill: "#004FD2"
  }))), _line || (_line = /*#__PURE__*/React.createElement("line", {
    y1: 27.5,
    x2: 75,
    y2: 27.5,
    stroke: "#004FD2",
    strokeWidth: 3
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 181,
    y1: 27.5,
    x2: 256,
    y2: 27.5,
    stroke: "#004FD2",
    strokeWidth: 3
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_945_129",
    transform: "scale(0.0078125)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_945_129",
    width: 128,
    height: 128,
    xlinkHref: "data:image/png;base64,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"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeaderBottom);
export default __webpack_public_path__ + "static/media/HeaderBottom.fad8ea73736075dc2deac7673435fed5.svg";
export { ForwardRef as ReactComponent };